import { Home4 } from "../pages/tema4/Home4";
import { IntroductionTema4 } from "../pages/tema4/introductionTema4";
import { SubtopicOneActivityOne } from "../pages/tema4/TopicOne/SubtopicOneActivityOne";
import { SubtopicOneActivityTwo } from "../pages/tema4/TopicOne/SubtopicOneActivityTwo";
import { Topic4SubtopicOneFinalPoint } from "../pages/tema4/TopicOne/Topic4SubtopicOneFinalPoint";
import { Tema4SubtopicTwoActivityOne } from "../pages/tema4/TopicTwo/Tema4SubtopicTwoActivityOne";
import { Tema4SubtopicTwoActivityTwo } from "../pages/tema4/TopicTwo/Tema4SubtopicTwoActivityTwo";
import { Tema4SubtopicTwoFinalPoint } from "../pages/tema4/TopicTwo/Tema4SubtopicTwoFinalPoint";
import { Tema4SubtopicThreeActivityOne } from "../pages/tema4/TopicThree/Tema4SubtopicThreeActivityOne";
import { Tema4SubtopicThreeActivityTwo } from "../pages/tema4/TopicThree/Tema4SubtopicThreeActivityTwo";
import { Tema4SubtopicThreeFinalPoint } from "../pages/tema4/TopicThree/Tema4SuptopicThreeFinalPoint";
import { Tema4SubtopicFourActivityOne } from "../pages/tema4/TopicFour/Tema4SubtopicFourActivityOne";
import { Tema4SubtopicFourActivityTwo } from "../pages/tema4/TopicFour/Tema4SubtopicFourActivityTwo";
import { Tema4SubtopicFourActivityThree } from "../pages/tema4/TopicFour/Tema4SubtopicFourActivityThree";
import { Tema4SubtopicFourActivityFour } from "../pages/tema4/TopicFour/Tema4SubtopicFourActivityFour";
import { Tema4SubtopicFourActivityFive } from "../pages/tema4/TopicFour/Tema4SubtopicFourActivityFive";
import { Tema4SubtopicFourFinalPoint } from "../pages/tema4/TopicFour/Tema4SubtopicFourFinalPoint";
import { Tema4SubtopicFiveActivityOne } from "../pages/tema4/TopicFive/Tema4SubtopicFiveActivityOne";
import { Tema4SubtopicFiveActivityTwo } from "../pages/tema4/TopicFive/Tema4SubtopicFiveActivityTwo";
import { Tema4SubtopicFiveFinalPoint } from "../pages/tema4/TopicFive/Tema4SubtopicFiveFinalPoint";
import { Tema4SubtopicSixActivityOne } from "../pages/tema4/TopicSix/Tema4SubtopicSixActivityOne";
import { Tema4SubtopicSixActivityTwo } from "../pages/tema4/TopicSix/Tema4SubtopicSixActivityTwo";
import { Tema4SubtopicSixFinalPoint } from "../pages/tema4/TopicSix/Tema4SubtopicSixFinalPoint";
import { SubtopicFinalTema4 } from "../pages/tema4/SubtopicFinalTema4";

export const pathTema4 = {
	path: "home4",
	element: <Home4 />,
	children: [
		// {
		// 	path: "introduction",
		// 	element: <Introduction />,
		// },
		{
			path: "tema4",
			children: [
				{
					path: 'introduction',
					element: <IntroductionTema4 />,
				},
				{
					path: 'subtema1',
					children: [
						{
							path: 'activityOne',
							element: <SubtopicOneActivityOne />
						},
						{
							path: 'activityTwo',
							element: <SubtopicOneActivityTwo />
						},
						{
							path: "results",
							element: <Topic4SubtopicOneFinalPoint />,
						},
					]
				},
				{
					path: 'subtema2',
					children: [
						{
							path: 'activityOne',
							element: <Tema4SubtopicTwoActivityOne />
						},
						{
							path: 'activityTwo',
							element: <Tema4SubtopicTwoActivityTwo />
						},
						{
							path: "results",
							element: <Tema4SubtopicTwoFinalPoint />,
						},
					]
				},
				{
					path: 'subtema3',
					children: [
						{
							path: 'activityOne',
							element: <Tema4SubtopicThreeActivityOne />
						},
						{
							path: 'activityTwo',
							element: <Tema4SubtopicThreeActivityTwo />
						},
						{
							path: "results",
							element: <Tema4SubtopicThreeFinalPoint />,
						},
					]
				},
				{
					path: 'subtema4',
					children: [
						{
							path: 'activityOne',
							element: <Tema4SubtopicFourActivityOne />
						},
						{
							path: 'activityTwo',
							element: <Tema4SubtopicFourActivityTwo />
						},
						{
							path: 'activityThree',
							element: <Tema4SubtopicFourActivityThree />
						},
						{
							path: 'activityFour',
							element: <Tema4SubtopicFourActivityFour />
						},
						{
							path: 'activityFive',
							element: <Tema4SubtopicFourActivityFive />
						},
						{
							path: "results",
							element: <Tema4SubtopicFourFinalPoint />,
						},
					]
				},
				{
					path: 'subtema5',
					children: [
						{
							path: 'activityOne',
							element: <Tema4SubtopicFiveActivityOne />
						},
						{
							path: 'activityTwo',
							element: <Tema4SubtopicFiveActivityTwo />
						},
						{
							path: "results",
							element: <Tema4SubtopicFiveFinalPoint />,
						},
					]
				},
				{
					path: 'subtema6',
					children: [
						{
							path: 'activityOne',
							element: <Tema4SubtopicSixActivityOne />
						},
						{
							path: 'activityTwo',
							element: <Tema4SubtopicSixActivityTwo />
						},
						{
							path: "results",
							element: <Tema4SubtopicSixFinalPoint />,
						},
					]
				},
				{
					path: "final",
					element: <SubtopicFinalTema4 />,
				},
			]
		}
	]
}